module.exports = __webpack_public_path__ + "img/img29.534e96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img29.png
// module id = 206
// module chunks = 0